<button
    type="button"
    class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2"
    placement="bottom"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
    style="border: none; width: 36px; height: 36px;"
>
    <i class="black-text fas fa-ellipsis-h mt-0"></i>                                
</button>

<ng-template #content >
    <div class="popover-links popover-links--medium">
        <div class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3" (click)="p2pEditModalOpen()">
            <div class="d-flex align-items-center cursor--pointer">
                <i class="fas fa-pencil-alt p2p-popover-icon d-flex align-items-center mr-2 cursor--pointer"></i>
                <span class="body-2 cursor--pointer">Edit</span>
            </div>
        </div>
        <div class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3" (click)="p2pAddDonationsModalOpen()">
            <div class="d-flex align-items-center cursor--pointer">
                <i class="fas fa-donate p2p-popover-icon d-flex align-items-center mr-2 cursor--pointer"></i>
                <span class="body-2 cursor--pointer">Add Donation</span>
            </div>
        </div>

        <div class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3" (click)="notifyFundraiser()">
            <div class="d-flex align-items-center cursor--pointer">
                <i class="fas fa-bell p2p-popover-icon d-flex align-items-center mr-2 cursor--pointer"></i>
                <span class="body-2 cursor--pointer">Notify</span>
            </div>
        </div>
        
        <div [ngClass]="exportBtnClasses" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3" (click)="exportToExel()">
            <div class="d-flex align-items-center cursor--pointer">
                <i class="fas fa-arrow-down p2p-popover-icon d-flex align-items-center mr-2 cursor--pointer"></i>
                <span class="body-2 cursor--pointer">Export Donations</span>
            </div>
        </div>
        <div [ngClass]="moveTransactionsClasses" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3" (click)="p2pMoveTransactionModalOpen()">
            <div class="d-flex align-items-center cursor--pointer">
                <i class="fa fa-clone mr-2 p2p-popover-icon d-flex align-items-center mr-2 cursor--pointer"></i>
                <span class="body-2 cursor--pointer">Move Transaction(s)</span>
            </div>
        </div>
        @if(data.campaignData.campaignTypeData.pledgePerEvent){
            <div (click)="fulfillDonorsPledges()" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
                <div class="align-items-center cursor--pointer">
                    <i class="black-text fas fa-money-check-alt p2p-popover-icon cursor--pointer mr-2"></i>
                    <span class="body-2 cursor--pointer">Fulfill Donors Pledges</span>
                </div>
            </div>

            <div (click)="addMilestone()" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
                <div class="align-items-center cursor--pointer">
                    <i class="black-text fas fa-running p2p-popover-icon cursor--pointer mr-2"></i>
                    <span class="body-2 cursor--pointer">Add Milestone</span>
                </div>
            </div>
        }
        <div (click)="downloadQrCardsByUser()" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
            <div class="align-items-center cursor--pointer">
                <i class="black-text fas fa-qrcode p2p-popover-icon cursor--pointer mr-2"></i>
                <span class="body-2 cursor--pointer">Download Qr Cards</span>
            </div>
        </div>
        <div (click)="deleteUser()" class="popover__action d-flex align-items-center popover__action--border cursor--pointer px-3">
            <div class="align-items-center cursor--pointer">
                <i class="black-text far fa-trash-alt p2p-popover-icon cursor--pointer mr-2"></i>
                <span class="body-2 cursor--pointer">Delete</span>
            </div>
        </div>
    </div>
  </ng-template>